import React, { useEffect, useState } from 'react';
import { Menu, X, Terminal } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
export function Navbar() {
  const [isOpen, setIsOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const navLinks = [{
    name: 'Services',
    href: '#services'
  }, {
    name: 'About',
    href: '#about'
  }, {
    name: 'Location',
    href: '#location'
  }];
  return <nav className={`fixed w-full z-50 transition-all duration-300 ${scrolled ? 'bg-cyber-black/90 backdrop-blur-md border-b border-cyber-purple/30' : 'bg-transparent'}`} data-id="element-133">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-134">
        <div className="flex items-center justify-between h-20" data-id="element-135">
          {/* Logo */}
          <div className="flex-shrink-0 flex items-center gap-2 group cursor-pointer" data-id="element-136">
            <Terminal className="h-8 w-8 text-cyber-cyan group-hover:text-cyber-green transition-colors" data-id="element-137" />
            <span className="font-orbitron text-2xl font-bold text-white tracking-wider glitch-text" data-text="ALPHAGAMER" data-id="element-138">
              ALPHAGAMER
            </span>
          </div>

          {/* Desktop Menu */}
          <div className="hidden md:block" data-id="element-139">
            <div className="ml-10 flex items-baseline space-x-8" data-id="element-140">
              {navLinks.map(link => <a key={link.name} href={link.href} className="font-rajdhani font-semibold text-lg text-gray-300 hover:text-cyber-cyan hover:shadow-[0_0_10px_rgba(0,240,255,0.5)] transition-all px-3 py-2 rounded-md uppercase tracking-widest" data-id="element-141">
                  {link.name}
                </a>)}
              <button className="bg-cyber-purple/20 border border-cyber-purple text-cyber-purple hover:bg-cyber-purple hover:text-white px-4 py-2 rounded font-orbitron text-sm transition-all duration-300" data-id="element-142">
                JOIN CLUB
              </button>
            </div>
          </div>

          {/* Mobile menu button */}
          <div className="md:hidden" data-id="element-143">
            <button onClick={() => setIsOpen(!isOpen)} className="text-gray-300 hover:text-white p-2" data-id="element-144">
              {isOpen ? <X className="h-8 w-8" data-id="element-145" /> : <Menu className="h-8 w-8" data-id="element-146" />}
            </button>
          </div>
        </div>
      </div>

      {/* Mobile Menu */}
      <AnimatePresence data-id="element-147">
        {isOpen && <motion.div initial={{
        opacity: 0,
        height: 0
      }} animate={{
        opacity: 1,
        height: 'auto'
      }} exit={{
        opacity: 0,
        height: 0
      }} className="md:hidden bg-cyber-black border-b border-cyber-purple/30 overflow-hidden" data-id="element-148">
            <div className="px-2 pt-2 pb-3 space-y-1 sm:px-3" data-id="element-149">
              {navLinks.map(link => <a key={link.name} href={link.href} onClick={() => setIsOpen(false)} className="block px-3 py-4 text-center font-orbitron text-xl text-gray-300 hover:text-cyber-cyan hover:bg-cyber-white/5" data-id="element-150">
                  {link.name}
                </a>)}
            </div>
          </motion.div>}
      </AnimatePresence>
    </nav>;
}